import { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue';

const todoRouter: RouteConfig = {
  path: '/report',
  component: Layout,
  meta: {
    title: 'route.report',
    icon: 'iconrenwu0',
    activeMenu: ['/report'],
    alwaysShow: false,
    permissions: ['Report_ViewOtherDepartments', 'Report_ViewDepartment', 'Report_ViewCompany', 'Report_ViewModule', 'Report_ViewProject'],
  },
  children: [
    {
      path: '/report/summary',
      name: 'SummarySheet',
      component: () => import('@/views/report/summarySheet.vue'),
      meta: {
        title: 'route.reportSummary',
        activeMenu: ['/report/summary'],
        breadcrumb: [
          {title: 'route.reportSummary', path: '/report/summary'},
        ],
      },
    },
    {
      path: '/report/detail',
      name: 'DetailSheet',
      component: () => import('@/views/report/detailSheet.vue'),
      meta: {
        title: 'route.reportDetail',
        activeMenu: ['/report/detail'],
        breadcrumb: [
          {title: 'route.reportDetail', path: '/report/detail'},
        ],
      },
    },
  ],
};

export default todoRouter;
